// Public, search-only credentials. The admin key must never reach browser code.
export const SEARCH_CONFIG = {
  appId: "TY6QHH3W2J",
  searchKey: "066bcfa783b5d9f2793f859cb9566aa8",
  indexPrefix: "modex",
};

// Sentinels rather than real tags: the highlighted value is escaped before the marks are
// restored, so Algolia content can never inject markup.
export const HIGHLIGHT_PRE = "__mx_hl__";
export const HIGHLIGHT_POST = "__/mx_hl__";

let cachedClient = null;

export function getLocale(pathname = window.location.pathname) {
  const match = /^\/(ua|pl)(\/|$)/.exec(pathname);
  return match ? match[1] : "en";
}

// Polish picks the noun form by the last digits: 1 wynik, 2-4 wyniki, 5+ and 12-14 wyników.
export function resultsPl(n) {
  const form =
    n === 1
      ? "wynik"
      : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14)
        ? "wyniki"
        : "wyników";
  return `${n.toLocaleString("pl")} ${form}`;
}

export function getIndexName(locale = getLocale()) {
  return `${SEARCH_CONFIG.indexPrefix}_${locale}`;
}

function getClientFactory() {
  const lite = window["algoliasearch/lite"];
  const legacy = window.algoliasearch;
  return (lite && lite.liteClient) || (legacy && (legacy.liteClient || legacy)) || null;
}

export function getSearchClient() {
  if (cachedClient) return cachedClient;

  const factory = getClientFactory();
  if (typeof factory !== "function") return null;

  cachedClient = factory(SEARCH_CONFIG.appId, SEARCH_CONFIG.searchKey);
  return cachedClient;
}

export function resetSearchClient() {
  cachedClient = null;
}

export async function runSearch({ query, hitsPerPage, page = 0, locale = getLocale() }) {
  const client = getSearchClient();
  if (!client) throw new Error("Algolia search client unavailable");

  const response = await client.search({
    requests: [
      {
        indexName: getIndexName(locale),
        query,
        hitsPerPage,
        page,
        filters: `locale:${locale}`,
        attributesToSnippet: ["description:28", "body:32"],
        attributesToHighlight: ["title"],
        highlightPreTag: HIGHLIGHT_PRE,
        highlightPostTag: HIGHLIGHT_POST,
        snippetEllipsisText: "…",
      },
    ],
  });

  return (response && response.results && response.results[0]) || null;
}
